import { isPaymentMethodExpired } from './helpers';

/**
 * Format card expiry from MMYY to MM/YY display format
 */
export const formatCardExpiry = (expiry = ''): string => {
  if (!expiry) return '';
  if (expiry.includes('/')) return expiry;
  if (expiry.length === 4) {
    const month = expiry.substring(0, 2);
    const year = expiry.substring(2, 4);
    return `${month}/${year}`;
  }
  return expiry;
};

/**
 * @deprecated Use isPaymentMethodExpired from ./helpers instead
 * This is kept for backward compatibility
 */
export const hasPaymentMethodCardExpired = (expiry?: string): boolean => {
  return isPaymentMethodExpired(expiry || '');
};

/**
 * Validate payment amount
 * @param amount - The amount to validate
 * @param balanceDue - The balance due
 * @param minPaymentAmount - Minimum payment amount allowed (default $10)
 * @param isCustomAmount - Whether this is a custom amount (not balance due)
 */
export const validatePaymentAmount = (
  amount: number,
  balanceDue: number,
  minPaymentAmount: number = 10,
  isCustomAmount: boolean = true,
): { valid: boolean; error?: string } => {
  // If paying full balance, always valid
  if (!isCustomAmount) return { valid: true };
  
  // Amount must be positive
  if (amount <= 0) {
    return { valid: false, error: 'Amount must be greater than 0' };
  }
  
  // Special case: balance is less than minimum - must pay exact balance
  const canPayBalanceUnderMin = balanceDue > 0 && balanceDue < minPaymentAmount;
  if (canPayBalanceUnderMin) {
    if (Math.abs(amount - balanceDue) >= 0.005) {
      return { valid: false, error: `To pay less than $${minPaymentAmount}, choose Balance due.` };
    }
    return { valid: true };
  }
  
  // Standard case: must meet minimum
  if (amount < minPaymentAmount) {
    return { valid: false, error: `Please add a minimum payment of $${minPaymentAmount} to complete this transaction` };
  }
  
  return { valid: true };
};


